<section class="dialog-content padding-top-30" *ngIf="dialogData" [ngClass]="dialogData.skin">
	<icon *ngIf="dialogData.showClose" type="times" class="close-icon" (click)="close()"></icon>
	<div class="header text-align-center padding-horizontal-20 padding-top-20">
		<ng-container *ngIf="dialogData.iconType">
			<img ada-decorative [remote-src]="dialogData.iconType" onerror="this.style.display = 'none'" />
		</ng-container>
		<p class="title text-medium text-bold text-20 padding-top-10" [innerHTML]="dialogData.title"></p>
		<p class="description text-14" [innerHTML]="dialogData.message || ''" [ngClass]="dialogData.messageClass"></p>
	</div>
	<p *ngIf="dialogData.body" class="padding-vertical-40 padding-horizontal-65" [innerHTML]="dialogData.body"></p>
	<div class="action-panel text-align-right">
		<button
			*ngFor="let action of dialogData.actions; let i = index"
			dz-button
			[color]="action.dialogActionClass === 'btn-secondary' ? 'secondary' : 'primary'"
			class="text-14 display-inline margin-right-20"
			(click)="onClick(i)"
			[track-event]="action.analyticsLinkEvent"
		>
			{{ action.label }}
		</button>
	</div>
</section>
